import { axiosSecure, handleError, handleResponse, RequestResponse } from './config';

export const getNftRedemptions = async (collectionId: string): Promise<RequestResponse> => {
   return await axiosSecure
      .get(`/nft-redemptions?collectionId=${collectionId}`)
      .then((response) => handleResponse(response))
      .catch(handleError);
};
